import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import { Col, Form } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import React from "react";

const OrderSourceTypeGroup: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => (
  <Form.Group as={Col} md={6} xl={4}>
    <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "sourceType")}</Form.Label>
    <FakeInput target={vm.item.chargeOrderDetail} property="sourceType" valueFormatter={value => vm.translateSourceType(value)} />
  </Form.Group>
));

export default OrderSourceTypeGroup;
